/*
 * //取整
 * parseInt(a,10); //Before
 * Math.floor(a); //Before
 * a>>0; //Before
 * ~~a; //After
 * a|0; //After
 * 
 * //四舍五入
 * Math.round(a); //Before
 * a+.5|0; //After
 * 
 * //内置值
 * undefined; //Before
 * void 0; //After, 快
 * 0[0]; //After, 略慢
 * 
 * //内置值
 * Infinity;
 * 1/0;
 * 
 * //布尔值短写法
 * true; //Before
 * !0; //After
 * 
 * //布尔值短写法
 * false; //Before
 * !1; //After
 */

/**
 * includes
 * [include description]
 * @param  {[type]} obj [description]
 * @param  {[type]} str [description]
 * @return {[type]}     [description]
 */
export function include(obj, str) {
    if(obj && (_type.arr(obj).arr || _type.str(obj).str) && (_type.str(str).str || _type.num(str).num)){
        return obj.includes(str);
    } else {
        return false;
    }
}

/**
 * 数组去重
 * [newarr description]
 * @param  {[type]} arr [description]
 * @return {[type]}     [description]
 */
export function newarr(arr){
    var arrs = [];
    for(var i =0;i<arr.length;i++){
        if(arrs.indexOf(arr[i]) == -1){
            arrs.push(arr[i])
        }
    }
    return arrs;
}

/**
 * 判断object是否为空
 * [isObjectEmpty description]
 * @param  {[type]}  arr [description]
 * @return {Boolean}     [description]
 */
export function isObjectEmpty(arr){
    for(var i in arr){
        return false;
    }
    return true;
}

/**
 * object 按id大小排序 升序
 * [sortIdUp description]
 * @param  {[type]} a [description]
 * @param  {[type]} b [description]
 * @return {[type]}   [description]
 */
export function sortIdUp(a,b){
  return a.id-b.id
}

/**
 * object 按id大小排序 降序
 * [sortIdDown description]
 * @param  {[type]} a [description]
 * @param  {[type]} b [description]
 * @return {[type]}   [description]
 */
export function sortIdDown(a,b){
  return b.id-a.id
}

/**
 * 邮箱验证--正则
 * [isEmail description]
 * @param  {[type]}  emailStr [description]
 * @return {Boolean}          [description]
 */
export function isEmail(emailStr) {
    var reg = /^[a-zA-Z0-9]+([._-]*[a-zA-Z0-9]*)*@[a-zA-Z0-9]+.[a-zA-Z0-9{2,5}$]/;
    var result = reg.test(emailStr);
    return result;
}

/**
 * array 去重
 * [unipue description]
 * @param  {[type]} array [description]
 * @return {[type]}       [description]
 */
export function unique(array){
    return Array.from(new Set(array))
}

/**
 * 多数组合并去重
 * [moreUnique description]
 * @param  {[type]} array [description]
 * @return {[type]}       [description]
 */
export function moreUnique(array){
    let arr = [];
    for(let i = 0; i < array.length; i++){
        arr.push(...array[i])
    }
    return Array.from(new Set(arr))
}

/**
 * 取两个数组共有的元素
 * [intersect description]
 * @param  {[type]} array1 [description]
 * @param  {[type]} array2 [description]
 * @return {[type]}        [description]
 */
export function intersect (array1,array2){
    return Array.from(new Set([...array1].filter(x => array2.includes(x))));
}

/**
 * 数组差集
 * [difference description]
 * @param  {[type]} array1 [description]
 * @param  {[type]} array2 [description]
 * @return {[type]}        [description]
 */
export function difference (array1,array2){
    return Array.from(new Set([...array1].filter(x => !array2.includes(x))));
}

/**
 * 数组求和
 * [reduce description]
 * @param  {[type]} array [description]
 * @return {[type]}       [description]
 */
export function reduce(array){
    return array.reduce((a,b) => a + b);
}

/**
 * 字符串去重
 * [strUnique description]
 * @param  {[type]} str [description]
 * @return {[type]}     [description]
 */
export function strUnique(str){
    return [...new Set(str)].join('');
}

/**
 * 判断浏览器类型
 * [browserType description]
 * @return {[type]} [description]
 */
export function browserType(){
    var browser = window.navigator.userAgent; //获取浏览器
    if (browser.indexOf("Opera") > -1) {
        return "Opera"
    }; //判断是否Opera浏览器
    if (browser.indexOf("Firefox") > -1) {
        return "FireFox";
    } //判断是否Firefox浏览器
    if (browser.indexOf("Chrome") > -1){
        return "Chrome";
    }
    if (browser.indexOf("Safari") > -1) {
        return "Safari";
    } //判断是否Safari浏览器
    if (browser.indexOf("compatible") > -1 && browser.indexOf("MSIE") > -1 && !isOpera) {
        return "IE";
    }; //判断是否IE浏览器
}

/**
 * 判断终端类型（手机端、PC端）
 * [terminalType description]
 * @return {[type]} [description]
 */
export function terminalType(){
    var browser = window.navigator.userAgent; //获取浏览器
    if (userAgent.indexOf("Android") > -1) {
        return "Android"
    }; //判断是否安卓手机
    if (userAgent.indexOf("iPhone") > -1) {
        return "iPhone";
    } //判断是是否苹果手机
}

/**
 * typeof
 * [_type description]
 * @type {Object}
 */
export const _type = {
    num:function (obj) {
        return (typeof obj === 'number');
    },
    str:function (obj) {
        return (typeof obj === 'string');
    },
    fun:function (obj) {
        return (typeof obj === 'function');
    },
    arr:function (obj) {
        return (typeof obj === 'object' && !this.obj(obj));
    },
    obj:function (obj) {
        return (typeof obj === 'object' && obj.length === undefined);
    },
    bool:function (obj) {
        return (typeof obj === 'boolean');
    }
}


/**
 * 字符自增
 * [numAdd description]
 * @param  {[type]} obj [description]
 * @param  {Number} num [description]
 * @return {[type]}     [description]
 */
export function numAdd(obj, num = 1){
    return String.fromCharCode(obj.charCodeAt() + num);
}

/**
 * 字符自减
 * [numMinus description]
 * @param  {[type]} obj [description]
 * @param  {Number} num [description]
 * @return {[type]}     [description]
 */
export function numMinus(obj, num = 1){
    return String.fromCharCode(obj.charCodeAt() - num);
}

/**
 * 获取start到end的字符或数组
 * [range description]
 * @param  {[type]} start [description]
 * @param  {[type]} end   [description]
 * @param  {Number} step  [description]
 * @return {[type]}       [description]
 */
export function range(start, end, step = 1) {
    var arr = []
    for (var i = start; i <= end; i += step) {
        arr.push(i)
    }
    return arr
}





/*html获取或html符号转码*/

/**
 * [HTML2Escape description]
 * @param {[type]} sHtml [description]
 * '<ul></ul>' ===> '&lt;ul&gt;&lt;/ul&gt;'
 */
export function HTML2Escape(sHtml) {
    var arrEntities = {
        '<': '&lt;',
        '>': '&gt;',
        // '&': '&amp;',
        '\'': '&#39;',
        '"': '&quot;',
        '“': '&ldquo;',
        '”': '&rdquo;'
    }
    return sHtml.replace(/[<>'"“”]/g, function (c) { return arrEntities[c] })
}

/**
 * [escape2HTML description]
 * @param  {[type]} str [description]
 * @return {[type]}     [description]
 * '&lt;ul&gt;&lt;/ul&gt;' ===> '<ul></ul>'
 */
export function escape2HTML(str) {
    var arrEntities = {
        'lt': '<',
        'gt': '>',
        'nbsp': ' ',
        // 'amp': '&',
        '#39': '\'',
        'quot': '"',
        'ldquo': '“',
        'rdquo': '”'
    }
    return str.replace(/&(lt|gt|nbsp|#39|quot|ldquo|rdquo);/ig, function (all, t) { return arrEntities[t] })
}

/**
 * [HTML_TAGS_REGEX description]
 * @type {RegExp}
 */
export const HTML_TAGS_REGEX = /(<([^>]+)>)/ig;

/**
 * 设置和获取localStorage和sessionStorage
 * [local_s description]
 * @type {Object}
 */
export const local_session = {
    get(item, storage = 'localStorage') {
        return window[storage].getItem(item) || "";
    },
    set(item, val, storage = 'localStorage') {
        if(item === ""){
            return;
        }
        return window[storage].setItem(item, val)
    }
}

export const cookie = {
    get(name){
        var cookieArray=document.cookie.split("; "); //得到分割的cookie名值对    
        var cookie=new Object();    
        for (var i=0;i<cookieArray.length;i++){    
           var arr=cookieArray[i].split("=");       //将名和值分开    
           if(arr[0]==name)return unescape(arr[1]); //如果是指定的cookie，则返回它的值    
        } 
        return ""; 
    },
    set(objName,objValue,objHours = 24){
        console.log(1);
        var str = objName + "=" + escape(objValue);
        if(objHours > 0){                               //为时不设定过期时间，浏览器关闭时cookie自动消失
            var date = new Date();
            var ms = objHours*3600*1000;
            date.setTime(date.getTime() + ms);
            str += "; expires=" + date.toGMTString();
        }
        document.cookie = str;
    },
    remove(name){
        document.cookie = name+"=;expires="+(new Date(0)).toGMTString();
    }
} 


/**
 * 获取特定class下的span元素
 * [MATH_TEX_REGEX description]
 * @type {RegExp}
 */
export const MATH_TEX_REGEX = /<span class="math-tex">(.*?)<\/span>/ig

/**
 * 提取元素中的纯文本部分内容 返回数组
 * [description]
 * @param  {[type]} el [description]
 * @return {[type]}    [description]
 */
export function extractPureText(el) {
    //jquery
    var arr = [];
    $(el).contents().each(function() {
        if(this.nodeType === 3) {
            for(var b = 0; b < this.whovarext.split(/[\n,]/g).length; b++){
                arr.push(this.whovarext.split(/[\n,]/g)[b])
            }
        }
    });

    return arr;
}




/*时间处理*/

/**
 * 给Date填加自定义原型
 * 获取时间的方法:
 *     var d = new Date()
 *     var dd = {
 *         y:d.Y,
 *         m:d.M,
 *         w:d.W,
 *         d:d.D,
 *         h:d.H,
 *         mm:d.M,
 *         s:d.s,
 *         ms:d.ms,
 *     }
 * [description]
 * @param  {[type]} ){return this.getFullYear()} [description]
 * @return {[type]}           [description]
 */
Date.prototype.__defineGetter__("Y", function(){return this.getFullYear()});
Date.prototype.__defineGetter__("M", function(){return (this.getMonth() + 1)});
Date.prototype.__defineGetter__("W", function(){return this.getDay()});
Date.prototype.__defineGetter__("D", function(){return this.getDate()});
Date.prototype.__defineGetter__("H", function(){return this.getHours()});
Date.prototype.__defineGetter__("m", function(){return this.getMinutes()});
Date.prototype.__defineGetter__("s", function(){return this.getSeconds()});
Date.prototype.__defineGetter__("ms", function(){return this.getMilliseconds()});


export const date = new Date();

/**
 * 获取给定的时间一年有多少毫秒
 * [yearMS description]
 * @param  {[type]} time [description]
 * @return {[type]}      [description]
 */
export function yearMS(time){
    var d = 0;
    if(typeof time === "number"){
        d = new Date(time);
    }else{
        d = DateToTime(time);
    }
    var y_ms = (d.Y % 4) === 0 ? 366 : 365;
    return (y_ms *24*3600*1000);
}

/**
 * 根据format获取当前年月日时分秒
 * [DateFormat description]
 * @param {[type]} f [description]
 */
export function DateFormat(f){
    var format = ["Y-M-D h:m:s", "Y-M-D", "h:m:s", "Y-M", "M-D", "h:m", "m:s"];
    if(include(format, f)){
        var i = format.indexOf(f);
        if(i === 0){
            return (date.Y + "-" + (date.M < 10 ? ('0' + date.M) : date.M) + "-" + (date.D < 10 ? ('0' + date.D) : date.D) + " " + (date.H < 10 ? ('0' + date.H) : date.H) + ":" + (date.m < 10 ? ('0' + date.m) : date.m) + ":" + (date.s < 10 ? ('0' + date.s) : date.s));
        } else if (i === 1){
            return (date.Y + "-" + (date.M < 10 ? ('0' + date.M) : date.M) + "-" + (date.D < 10 ? ('0' + date.D) : date.D));
        } else if (i === 2){
            return ((date.H < 10 ? ('0' + date.H) : date.H) + ":" + (date.m < 10 ? ('0' + date.m) : date.m) + ":" + (date.s < 10 ? ('0' + date.s) : date.s));
        } else if (i === 3){
            return (date.Y + "-" + (date.M < 10 ? ('0' + date.M) : date.M));
        } else if (i === 4){
            return ((date.M < 10 ? ('0' + date.M) : date.M) + "-" + (date.D < 10 ? ('0' + date.D) : date.D));
        } else if (i === 5){
            return ((date.H < 10 ? ('0' + date.H) : date.H) + ":" + (date.m < 10 ? ('0' + date.m) : date.m));
        } else if (i === 6){
            return ((date.m < 10 ? ('0' + date.m) : date.m) + ":" + (date.s < 10 ? ('0' + date.s) : date.s));
        }
    } else {
        console.error("格式不对")
    }
}

/**
 * 获取当前时间戳 毫秒
 * [DateTimeMS description]
 */
export function DateTimeMS(dd = ''){
    if(dd){
        return new Date(dd).getTime();
    }else{
        return new Date().getTime();
    }
}

/**
 * 获取当前时间戳 秒
 * [DateTimeS description]
 */
export function DateTimeS(dd = ''){
    if(dd){
        return (Date.parse(new Date(dd)) / 1000);
    }else{
        return (Date.parse(new Date()) / 1000);
    }
}

/**
 * 获取给定日期所在周的第一天
 * [getMonDate description]
 * @param  {[type]} dd [description]
 * @return {[type]}    [description]
 */
export function getMonDate(dd=null){
    var d;
    if(dd){
        d = new Date(dd);
    }else{
        d = new Date();
    }
    var day=d.getDay(),
        date=d.getDate();
    if(day === 1)
        return d;
    if(day === 0)
        d.setDate(date-6);
    else
        d.setDate(date-day+1);
    return d;
}

/**
 * 获取给定日期所在的周的第一天和最后一天的 时间戳
 * [getWeekStartToEnd description]
 * @param  {[type]} d [description]
 * @return {[type]}   [description]
 */
export function getWeekStartToEnd(d){
    var o = {
        start:new Date(new Date(this.getMonDate(d)).toLocaleDateString()).getTime(),
        end:new Date(new Date(this.getMonDate(d)).toLocaleDateString()).getTime() + 7 * 24 * 60 * 60 * 1000 - 1
    };
    return o;
}

/**
 * 获取给定日期所在的月的天数
 * [getMonthDayLength description]
 * @param  {[type]} d [description]
 * @return {[type]}   [description]
 */
export function getMonthDayLength(d = null){
    var date = new Date();
    if(d){
        date = new Date(d);
    }
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var arr = [1, 3, 5, 7, 8, 10, 12];
    if (m === 2) {
        if((y % 4) === 0) {
            return 29;
        }else{
            return 28;
        }
    } else if (arr.includes(m)) {
        return 31;
    } else {
        return 30;
    }
}

/**
 * 获取给定日期所在的月的第一天和最后一天的 时间戳
 * [getWeekStartToEnd description]
 * @param  {[type]} d [description]
 * @return {[type]}   [description]
 */
export function getMonthStartToEnd(d){
    var date = new Date();
    if(d){
        date = new Date(d);
    }
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var o = {
        start:new Date(new Date(y + '/' + m + '/1').toLocaleDateString()).getTime(),
        end:new Date(new Date(y + '/' + m + '/1').toLocaleDateString()).getTime() + this.getMonthDayLength(d) * 24 * 60 * 60 * 1000 - 1
    }
    return o;
}

/**
 * 根据时分返回时间戳
 * '06:00 | 06:00:00' => 21600000
 * [timeToStamp description]
 * @param  {[type]} time [description]
 * @return {[type]}      [description]
 */
export function timeToStamp(time){
    var arr = time.split(':');
    if(arr.length === 3){
        return ((Number(arr[0]) * 60 + Number(arr[1])) * 60 + Number(arr[2])) * 1000;
    }else if(arr.length === 2){
        return (Number(arr[0]) * 60 + Number(arr[1])) * 60 * 1000;
    }
}

/**
 * 根据时间戳转化时间
 * [TimeToDate description]
 * @param {[type]} timestamp [description]
 */
export function TimeToDate(timestamp){
    var d = new Date(timestamp);
    return (d.Y + "-" + (d.M < 10 ? ('0' + d.M) : d.M) + "-" + (d.D < 10 ? ('0' + d.D) : d.D) + " " + (d.H < 10 ? ('0' + d.H) : d.H) + ":" + (d.m < 10 ? ('0' + d.m) : d.m) + ":" + (d.s < 10 ? ('0' + d.s) : d.s));
}

/**
 * 年月日时间转1999-09-09 09:09:09
 * [DateToTime description]
 * @param {[type]} date [description]
 */
export function ChinaDToDate(dd){
    var d1 = dd.replace(/\s+/g, "");
    var d2 = d1.replace(/年/, "-");
    var d3 = d2.replace(/月/, "-");
    var d4 = d3.replace(/日/, " ");
    var d5 = d4.replace(/时/, ":");
    var d6 = d5.replace(/分/, ":");
    var d7 = d6.replace(/秒/, "");
    return d7;
}

/**
 * 1999-09-09 09:09:09转年月日时间
 * [DateToTime description]
 * @param {[type]} date [description]
 */
export function DateToChinaD(dd){
    var d1 = dd.split(" ");
    var d2 = d1[0].split("-");
    var d3 = d1[1].split(":");
    return (d2[0] + '年' + d2[1] + '月' + d2[2] + '日' + d3[0] + '时' + d3[1] + '分' + d3[2] + '秒');
}

/**
 * 返回距离当前时间多长
 * [distanceNowTime description]
 * @param  {[type]} time [description]
 * @return {[type]}      [description]
 */
export function distanceNowTime(startTime,endTime){
    var s_month = parseInt(startTime.split("-")[1].replace(/^0+/, ""));
    var end, e_month;
    if(!endTime){
        end = DateTimeMS();
        e_month = data.M;
    }else{
        end = DateToTime(endTime)
        e_month = parseInt(endTime.split("-")[1].replace(/^0+/, ""));
    }
    var len_time = end - DateToTime(startTime);
    var flag = true;
    if(end - DateToTime(startTime) < 0){
        flag = false;
        len_time = DateToTime(startTime) - end;
    }

    //获取年
    /*var sd = new Date(startTime);
    var ed = new Date(end);
    var years = Math.abs(ed.Y - sd.Y);
    var len_days = 365;
    var leave1 = len_time;
    if(years > 0){
        var s = sd > ed ? ed : sd;
        var e = ed > sd ? ed : sd;
        for(var i = s.Y; i < e.Y; i++){
            if((i%4) === 0 && i === s.Y && s.M < 2){
                len_days = 366;
            } else {
                if((i%4) === 0){}
            }
            len_days = (i % 4) === 0 ? 366 : 365
            leave1 = leave1 - (24* len_days *3600*1000);
        }
    }*/
    len_days = (sd.Y % 4) === 0 ? 366 : 365;
    var years=Math.floor(len_time/( len_days *24*3600*1000));
    var leave1=len_time%(24* len_days *3600*1000);

    var leave2 = leave1;

    /*var days_arr = []
    function getMonthDays(i){
        if(i === 1 || i === 3 || i === 5 || i === 7 || i === 8 || i === 10 || i === 12){
            days_arr.push(31);
        } else if(i === 2){
            if((parseInt(startTime.split("-")[0]) % 4) === 0){
                days_arr.push(29)
            } else {
                days_arr.push(28)
            }
        } else {
            days_arr.push(30)
        }
    }

    if(years > 0){
        for(var i = (s_month + 1); i < 13; i++){
            getMonthDays(i)
        }

        for(var i = 1; i < (e_month + 1); i++){
            getMonthDays(i)
        }
    } else {
        for(var i = (s_month + 1); i < (e_month + 1); i++){
            getMonthDays(i)
        }
    }
    var months = days_arr.length;

    if(months > 0){
        for(var i = 0; i < days_arr.length; i++){
            leave2 -= leave1 - days_arr[i] *24*3600*1000;
        }
    }*/





    //获取日
    var days=Math.floor(leave2/(24*3600*1000))
    var leave3=leave2%(24*3600*1000)

    //获取时
    var hours=Math.floor(leave3/(3600*1000))
    var leave4=leave3%(3600*1000)

    //获取分
    var minutes=Math.floor(leave4/(60*1000))
    var leave5=leave4%(60*1000)

    //获取秒
    var seconds=Math.round(leave5/1000)

    var t = '';
    if(years > 0){
        t += years + "年" + days+" 天 "+hours+" 小时 "+minutes+" 分钟 "+seconds+" 秒";
    }else{
        if(days > 0){
            t += days+" 天 "+hours+" 小时 "+minutes+" 分钟 "+seconds+" 秒"
        }else{
            if(hours > 0){
                t += hours+" 小时 "+minutes+" 分钟 "+seconds+" 秒"
            }else{
                if(minutes > 0){
                    t += minutes+" 分钟 "+seconds+" 秒"
                }else{
                    t += seconds+" 秒"
                }
            }
        }
    }

    return [t, flag];
}

/**
 * 普通字符串时间转时间对象
 * [stringToDate description]
 * @param  {[type]} dateStr   [description]
 * @param  {[type]} separator [description]
 * @return {[type]}           [description]
 */
export function stringToDate(dateStr, separator) {
    if (!separator) {
        separator = '-'
    }
    var dateArr = dateStr.slice(0, 10).split(separator)
    var timeArr = dateStr.slice(11).split(":")
    var year = parseInt(dateArr[0])
    var month;
    if (dateArr[1].indexOf('0') == '0') {
        month = parseInt(dateArr[1].substring(1))
    } else {
        month = parseInt(dateArr[1])
    }
    var day = parseInt(dateArr[2])
    var hour = parseInt(timeArr[0]) || ''
    var minute = parseInt(timeArr[1]) || ''
    var second = parseInt(timeArr[2]) || ''
    var date = new Date(year, month - 1, day, hour, minute, second)
    return date
}

/**
 * 计算两个时间相差的年月日时分秒
 * [getTime description]
 * @param  {[type]} startTime [description]
 * @param  {[type]} endTime   [description]
 * @return {[type]}           [description]
 */
/*export function getDistanceTime(startTime, endTime) {
    var end;
    if (endTime) {
        end = this.stringToDate(endTime)
    } else {
        end = new Date()
    }
    var endYear = end.getFullYear();
    var endMonth = end.getMonth() + 1;
    var endDay = end.getDate();
    var endHour = end.getHours();
    var endMinute = end.getMinutes();
    var endSecond = end.getSeconds();

    var start = this.stringToDate(startTime);
    var startYear = start.getFullYear();
    var startMonth = start.getMonth() + 1;
    var startDay = start.getDate();
    var startHour = start.getHours();
    var startMinute = start.getMinutes();
    var startSecond = start.getSeconds();

    var year, month, day, hour, minute, second;
    year = (endYear - startYear) > 0 ? (endYear - startYear) : 0
    if (endMonth > startMonth) {
        month = endMonth - startMonth
    } else if (endMonth == startMonth) {
        month = 0
    } else {
        if (year > 0) {
            year = year - 1
        }
        month = 12 - startMonth + endMonth
    }
    if (endDay > startDay) {
        day = endDay - startDay
    } else if (endDay == startDay) {
        day = 0
    } else {
        if (startMonth == 1 ||
            startMonth == 3 ||
            startMonth == 5 ||
            startMonth == 7 ||
            startMonth == 8 ||
            startMonth == 10 ||
            startMonth == 12) {
            day = 31 - startDay + endDay
        } else if (startMonth == 2) {
            if (startYear % 4 == 0 && startYear % 100 != 0 || startYear % 400 == 0) {
                day = 29 - startDay + endDay
            } else {
            day = 28 - startDay + endDay
        } else {
            day = 30 - startDay + endDay
        }
        if (month > 0) {
            month = month - 1
        }
    }
    if (endHour > startHour) {
        hour = endHour - startHour
    } else if (endHour == startHour) {
        hour = 0
    } else {
        hour = 24 - startHour + endHour
        if (day > 0) {
            day = day - 1
        }
    }
    if (endMinute > startMinute) {
        minute = endMinute - startMinute
    } else if (endMinute == startMinute) {
        minute = 0
    } else {
        minute = 60 - startMinute + endMinute
        if (hour > 0) {
            hour = hour - 1
        }
    }
    if (endSecond > startSecond) {
        second = endSecond - startSecond
    } else if (endSecond == startSecond) {
        second = 0
    } else {
        second = 60 - startSecond + endSecond
        if (minute > 0) {
            minute = minute - 1
        }
    }
    return {
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second
    }
}*/

/**
 * 获取2018-1-1 01:01:01 日期
 * [timestampToTime description]
 * @param  {[type]} date [description]
 * @return {[type]}      [description]
 */
export function timestampToTime(date){
    let timestamp4 = new Date(date);
    return timestamp4.toLocaleDateString().replace(/\//g, "-") + " " + timestamp4.toTimeString().substr(0, 5)
}
export function dateStampToDate(date){
    let timestamp4 = new Date(date);
    return timestamp4.toLocaleDateString().replace(/\//g, "-")
}

/**
 * rgb或rgba 转 hex
 * [colorRGB2Hex description]
 * @param  {[type]} color [description]
 * @return {[type]}       [description]
 */
export function colorRGB2Hex(color) {
    var rgb = color.split(',');
    var r = parseInt(rgb[0].split('(')[1]);
    var g = parseInt(rgb[1]);
    var b = parseInt(rgb[2].split(')')[0]);
 
    var hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    return hex;
}


/**
 * 16进制字符串颜色转十进制
 * [colorStrTo16 description]
 * @param  {[type]} str [description]
 * @return {[type]}     [description]
 */
export function colorStrTo16(str){
    return parseInt(str, 16)
}


/**
 * 表单常用验证
 * [validate description]
 * @type {Object}
 */
export const validate = {
    //百家姓验证
    chineseFirstName: function(str){
        var firstName='赵钱孙李周吴郑王冯陈褚卫蒋沈韩杨朱秦尤许何吕施张孔曹严华金魏陶姜戚谢邹喻柏水窦章云苏潘葛奚范彭郎鲁韦昌马苗凤花方俞任袁柳酆鲍史唐费廉岑薛雷贺倪汤滕殷罗毕郝邬安常乐于时傅皮卞齐康伍余元卜顾孟平黄和穆萧尹姚邵湛汪祁毛禹狄米贝明臧计伏成戴谈宋茅庞熊纪舒屈项祝董梁杜阮蓝闵席季麻强贾路娄危江童颜郭梅盛林刁钟徐丘骆高夏蔡田樊胡凌霍虞万支柯昝管卢莫经房裘缪干解应宗丁宣贲邓郁单杭洪包诸左石崔吉钮龚程嵇邢滑裴陆荣翁荀羊于惠甄曲家封芮羿储靳汲邴糜松井段富巫乌焦巴弓牧隗山谷车侯宓蓬全郗班仰秋仲伊宫宁仇栾暴甘钭厉戎祖武符刘景詹束龙叶幸司韶郜黎蓟薄印宿白怀蒲邰从鄂索咸籍赖卓蔺屠蒙池乔阴郁胥能苍双闻莘党翟谭贡劳逄姬申扶堵冉宰郦雍郤璩桑桂濮牛寿通边扈燕冀郏浦尚农柴瞿阎充慕连茹习宦艾鱼容向古易慎戈廖庾终暨居衡步都耿满弘匡国文寇广禄阙东欧殳沃利蔚越夔隆师巩厍聂晁勾敖融冷訾辛阚那简饶空曾毋沙乜养鞠须丰巢关蒯相查后荆红游竺权逯盖益桓公万俟司马上官欧阳夏候诸葛闻人东方赫连皇甫尉迟公羊澹台公治宗政濮阳淳于单于太叔申屠公孙仲孙辕轩令狐钟离宇文长孙幕容鲜于闾丘司徒司空丌官司寇仉督子车颛孙端木巫马公西漆雕乐正壤驷公良拓拔夹谷宰父谷梁晋楚阎法汝鄢涂钦段干百里东郭南门呼延归海羊舌微生岳帅缑亢况后有琴梁丘左丘东门西门商牟佘佴佰赏南官墨哈谯笪年爱阳佟第五言福百家姓终百家姓以外的:万俟司马上官欧阳夏候诸葛闻人东方赫连皇甫尉迟公羊澹台公治宗政濮阳淳于单于太叔申屠公孙仲孙辕轩令狐钟离宇文长孙幕容鲜于闾丘司徒司空丌官司寇仉督子车颛孙端木巫马公西漆雕乐正壤驷公良拓拔夹谷宰父谷梁晋楚阎法汝鄢涂钦段干百里东郭南门呼延归海羊舌微生岳帅缑亢况后有琴梁丘左丘东门西门商牟佘佴佰赏南官墨哈谯笪年爱阳佟第五言福';
        var nameStr1=str.substring(0,1);  //获取输入的第一个字
        var nameStr2=str.substring(0,2);  //获取输入的前两个字
        var hasName=(firstName.indexOf(nameStr1)!=-1)||(firstName.indexOf(nameStr2)!=-1);   //判断是否含有姓氏
        //判断是否属于百家姓
        if(hasName){
            return true;
        }else{
            return false;
        }
    },
    number: function(number){
        var pattern = /^[0-9]$/;
        if(pattern.test(number)){
            return true;
        }else{
            return false;
        }
    },
    //中文字符验证
    chinese: function(str){
        var pattern = /[\u4e00-\u9fa5]/;
        if(pattern.test(number)){
            return true;
        }else{
            return false;
        }
    },
    //字母数字中文及下划线（一般用于用户名验证）
    wordsNumber_: function(str){
        var pattern = /[A-Za-z0-9_\-\u4e00-\u9fa5]+/;
        if(pattern.test(str)){
            return true;
        }else{
            return false;
        }
    },
    //英文验证
    english: function(str){
        var pattern = /^[a-zA-Z]$/;
        if(pattern.test(str)){
            return true;
        }else{
            return false;
        }
    },
    //电子邮箱验证
    email: function(str){
        var pattern = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
        if(pattern.test(str)){
            return true;
        }else{
            return false;
        }
    },
    //手机号码验证非+86
    cellphone: function(number){
        var pattern = /^1[3|4|5|7|8]\d{9}$/;
        if(pattern.test(number)){
            return true;
        }else{
            return false;
        }
    },
    //电话验证
    tellphone: function(number){
        var pattern = /[0-9-()（）]{7,18}/;
        if(pattern.test(number)){
            return true;
        }else{
            return false;
        }
    },
    //网址验证
    website: function(str){
        var pattern = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;
        if(pattern.test(str)){
            return true;
        }else{
            return false;
        }
    },
    ipAddress: function(str){
        var pattern = /(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)/;
        if(pattern.test(str)){
            return true;
        }else{
            return false;
        }
    },
    //身份证验证
    idCard: function(code){
        if(!code){
            return [false, '请输入身份证号码！']
        }

        let city = {11: "北京",12: "天津",13: "河北",14: "山西",15: "内蒙古",21: "辽宁",22: "吉林",23: "黑龙江 ",31: "上海",32: "江苏",33: "浙江",34: "安徽",35: "福建",36: "江西",37: "山东",41: "河南",42: "湖北 ",43: "湖南",44: "广东",45: "广西",46: "海南",50: "重庆",51: "四川",52: "贵州",53: "云南",54: "西藏 ",61: "陕西",62: "甘肃",63: "青海",64: "宁夏",65: "新疆",71: "台湾",81: "香港",82: "澳门",91: "国外 "};

        if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
            return false;
        } else if (!city[code.substr(0, 2)]) {
            return false;
        } else {
            //18位身份证需要验证最后一位校验位
            if (code.length == 18) {
                code = code.split('');
                //加权因子
                let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                //校验位
                let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                let sum = 0;
                let ai = 0;
                let wi = 0;
                for (let i = 0; i < 17; i++) {
                    ai = code[i];
                    wi = factor[i];
                    sum += ai * wi;
                }
                let last = parity[sum % 11];
                if (last != code[17]) {
                    return false;
                }
            }
        }
        return true;
    },
    //邮编验证
    postCodes: function(number){
        var pattern = /\d{6}/;
        if(pattern.test(number)){
            return true;
        }else{
            return false;
        }
    },
    //QQ验证
    tencentQQ: function(number){
        var pattern = /[1-9]([0-9]{5,11})/;
        if(pattern.test(number)){
            return true;
        }else{
            return false;
        }
    },
    //特殊字符验证
    specialWord: function(str){
        var pattern = /`~!@#$%^&*()_+-=[]{}\|;:'"<,>.?\//;
        if(pattern.test(str)){
            return true;
        }else{
            return false;
        }
    },
    //强密码验证(必须包含大小写字母和数字的组合，不能使用特殊字符，长度在8-16之间)
    strongPassword: function(str){
        var pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/;
        if(pattern.test(str)){
            return true;
        }else{
            return false;
        }
    },
    //日期格式验证 2016-01-01这种格式
    dataFormat: function(str){
        var pattern = /^[1-9]{1}\d{3}-[0-1]{1}\d{0,1}-[0-1]{1}\d{0,1}/;
        if(pattern.test(str)){
            return true;
        }else{
            return false;
        }
    }
}

/**
 * 获取input file 的文件
 * [fileToImg description]
 * @param  {[type]} file [description]
 * @return {[type]}      [description]
 */
export function fileToImg(file){
    let windowURL = window.URL || window.webkitURL;
    return windowURL.createObjectURL(file);
}

/**
 * 图片全屏展示 jquery
 * [fullImg description]
 * @param  {[type]} src [description]
 * @return {[type]}     [description]
 */
export function fullImg(src){
    $("body").append(`<div id="preview-img" style="position:fixed;width: 100%;height:100%;background: rgba(0,0,0,0.8);top: 0;left: 0;z-index: 1100;">
            <img src="${src}" alt="" style="position: absolute;top:0;left:0;right:0;bottom:0;margin:auto;max-width: 100%;max-height: 100%;">
        </div>`);
    $("#preview-img").click(function(){
        $(this).remove();
    })
}

// window.location.href /*url全部*/ === window.location.protocol /*协议*/ + '//' +
//                                      window.location.host /*主域*/ + 
//                                      window.location.port /*端口号*/ + 
//                                      window.location.pathname /*子域*/ + 
//                                      window.location.hash/*‘#’后面的*/ + 
//                                      window.location.search/*‘?’后面的

/**
 * url 处理
 * 
 * [urlDispose description]
 * @type {Object}
 */
export const urlDispose = {
    href: function(){
        return window.location.href;
    },
    protocol: function(){
        return window.location.protocol;
    },
    host: function(){
        return window.location.host;
    },
    port: function(){
        return window.location.port;
    },
    pathname: function(){
        return window.location.pathname;
    },
    hash: function(){
        return window.location.hash;
    },
    search: function(){
        return window.location.search()
    },
    urlValue: function(name) { 
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
        var r = window.location.search.substr(1).match(reg); 
        if (r != null) return unescape(decodeURIComponent(r[2])); 
        return null; 
    },
    urlKeyValue: function(){
        var r = window.location.search.substr(1);
        if (r != null) {
            var obj = new Object();
            var arr = unescape(r).split('&');
            for(var k = 0; k < arr.length; k++){
                if(arr[k].split("=")[0] === ""){
                    continue;
                }
                obj[arr[k].split("=")[0]] = arr[k].split("=")[1];
            }
            return obj;
        }else {
            return null;
        }
    }
}


/**
 * [mouseReady description]
 * @param  {[type]} object [description]
 * @return {[type]}        [description]
 *
 * 元素纵向或横向拉伸  jQuery
 * 
 * 参数 {
 *         el_way:      'clientY || clientX',       //拉伸方向                以下数据同方向一致
 *         el_class:    'class1',                   //操作判断是不是该元素    类名
 *         el_d:        $(".aaa"),                  //被操作的元素            发生变化的元素
 *         el_d_old_n:  200,                        //被操作元素的高度        Number
 *         el_d_min_n:  30,                         //被操作元素的最小高度    Number
 *         el_d_max_n:  500,                        //被操作元素的最大高度    Number
 *         el_func:     function(){                 //操作完之后执行的函数    function
 *                         console.log(111);
 *                      }
 *      }
 */
export function mouseReady(object){
    var obj = {
        el_way:      object.el_way,                //拉伸方向                以下数据同方向一致
        el_class:    object.el_class,              //操作判断是不是该元素    类名
        el_d:        object.el_d,                  //被操作的元素            发生变化的元素 
        el_d_old_n:  object.el_d_old_n || 0,       //被操作元素的高度        Number
        el_d_min_n:  object.el_d_min_n || '',      //被操作元素的最小高度    Number
        el_d_max_n:  object.el_d_max_n || '',      //被操作元素的最大高度    Number
        el_func:     object.el_func    || '',      //操作完之后执行的函数    function
    }
    var that = this;
    $(document).mousedown (function (e) {
        if(!$(e.target).hasClass(obj.el_class)){
            return false;
        }
        var deltaY = e[el_way];
        var timer = true;

        $(document).mousemove(function (e){
            timer = true;
            var lt = e[el_way] - deltaY;
            var n = obj.el_d_old_n + lt;
            if(obj.el_d_min_n){
                if(n <= obj.el_d_min_n){
                    n = obj.el_d_min_n;
                }
            }
            if(obj.el_d_max_n){
                if(n >= obj.el_d_max_n){
                    n = obj.el_d_max_n;
                }
            }
            if(el_way === 'clientY'){
                obj.el_d.height(n);
            }else if(el_way === 'clientX'){
                obj.el_d.width(n);
            }
        });
        $(document).mouseup (function(){
            $(document).unbind("mousemove");
            setTimeout(function () {
                if(timer){
                    obj.el_func
                    timer = false;
                }
            }, 500);
        });
    })
}

/**
 * 多维数组合并
 * [flatten description]
 * @param  {[type]} arr [description]
 * @return {[type]}     [description]
 */
export function flatten(arr){
    while (arr.some(item => Array.isArray(item))){
        arr = [].concat(...arr);
    }
    return arr;
}

/*
Array.from(new Set([1,2,3,4,4,5,5])) // 数组去重
[...new Set([1,2,3,4,4,5,5])]  // 数组去重
Math.max(...[1,2,3,4])
Math.max.apply(this,[1,2,3,4])
[1,2,3,4].reduce((prev, cur, curIndex, arr) => {
    console.log(prev, cur, curIndex, arr)
    return Math.max(prev, cur)
}, 0)
prev：上一次的返回值
cur：当前值
curIndex：当前值索引
arr：当前数组
Object.keys({name:"张三", age:14})
Object.values({name:"张三", age:14})
Object.entries({name:"张三", age:14})
*/

export function BrowserType()
{
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1; //判断是否Opera浏览器
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
    var isSafari = userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1 && userAgent.indexOf('Trident') == -1; //判断是否Safari浏览器
    var isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Edge") == -1; //判断Chrome浏览器
    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if(fIEVersion == 7)
        { return "IE7";}
        else if(fIEVersion == 8)
        { return "IE8";}
        else if(fIEVersion == 9)
        { return "IE9";}
        else if(fIEVersion == 10)
        { return "IE10";}
        else
        { return "0"}//IE版本过低
    }
    else if (isIE11) { return "IE11";}
    else if (isEdge) { return "Edge";}
    else if (isFF) { return "FF";}
    else if (isOpera) { return "Opera";}
    else if (isSafari) { return "Safari";}
    else if (isChrome) { return "Chrome";}
}


/**
 * 点击复制div的文本
 * [copyArticle description]
 * @param  {[type]}   con [description]
 * @param  {Function} cb  [description]
 * @return {[type]}       [description]
 */
export function copyArticle(con, cb = null) {
    const range = document.createRange();
    range.selectNode(document.getElementById(con));
    const selection = window.getSelection();
    if(selection.rangeCount > 0) selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
    if(cb){
        cb()
    }
}

/**
 * 虚拟DOM
 * [VD description]
 * @param {[type]} tagName  [description]
 * @param {[type]} props    [description]
 * @param {[type]} children [description]
 */
export function VD(tagName, props, children) {
    if (!(this instanceof VD)) {
        return new VD(tagName, props, children);
    }

    this.tagName = tagName;
    this.props = props || {};
    this.children = children || [];
    this.key = props ? props.key : undefined;

    let count = 0;
    this.children.forEach((child) => {
        if (child instanceof VD) {
            count += child.count;
        }
        count++;
    });
    this.count = count;
}
VD.prototype.render = function() {
    let el = document.createElement(this.tagName);
    let props = this.props;

    for (let propName in props) {
        /*let event_listener = [
            'onabort',//图像加载被中断
            'onblur',//元素失去焦点
            'onchange',//用户改变域的内容
            'onclick',//鼠标点击某个对象
            'ondblclick',//鼠标双击某个对象
            'onerror',//当加载文档或图像时发生某个错误
            'onfocus',//元素获得焦点
            'onkeydown',//某个键盘的键被按下
            'onkeypress',//某个键盘的键被按下或按住
            'onkeyup',//某个键盘的键被松开
            'onload',//某个页面或图像被完成加载
            'onmousedown',//某个鼠标按键被按下
            'onmousemove',//鼠标被移动
            'onmouseout',//鼠标从某元素移开
            'onmouseover',//鼠标被移到某元素之上
            'onmouseup',//某个鼠标按键被松开
            'onreset',//重置按钮被点击
            'onresize',//窗口或框架被调整尺寸
            'onselect',//当文本内容被选择时的事件
            'onsubmit',//提交按钮被点击
            'onunload',//用户退出页面
            'onafterprint',//当文档被打印后触发此事件
            'onafterupdate',//当数据完成由数据源到对象的传送时触发此事件
            'onauxclick',//在发送auxclick事件时调用的EventHandler，指示在输入设备上按下非主按钮（例如，鼠标中键）
            'onbeforecopy',//当页面当前的被选择内容将要复制到浏览者系统的剪贴板前触发此事件
            'onbeforecut',//当页面中的一部分或者全部的内容将被移离当前页面[剪贴]并移动到浏览者的系统剪贴板时触发此事件
            'onbeforeeditfocus',//当前元素将要进入编辑状态
            'onbeforepaste',//内容将要从浏览者的系统剪贴板传送[粘贴]到页面中时触发此事件
            'onbeforeprint',//当文档即将打印时触发此事件
            'onbeforeupdate',//当浏览者粘贴系统剪贴板中的内容时通知目标对象
            'onbounce',//在Marquee内的内容移动至Marquee显示范围之外时触发此事件
            'oncancel',
            'oncanplay',//在视频(video)准备开始播放时执行 JavaScript
            'oncanplaythrough',//当视频可以正常播放且无需停顿时执行 JavaScript
            'oncellchange',//当数据来源发生变化时
            'onclose',
            'oncontextmenu',//当浏览者按下鼠标右键出现菜单时或者通过键盘的按键触发页面菜单时触发的事件
            'oncopy',//当页面当前的被选择内容被复制后触发此事件
            'oncuechange',
            'oncut',//当页面当前的被选择内容被剪切时触发此事件
            'ondataavailable',//当数据接收完成时触发事件
            'ondatasetchanged',//数据在数据源发生变化时触发的事件
            'ondatasetcomplete',//当来子数据源的全部有效数据读取完毕时触发此事件
            'ondrag',//当某个对象被拖动时触发此事件 [活动事件]
            'ondragdrop',//一个外部对象被鼠标拖进当前窗口或者帧
            'ondragend',//当鼠标拖动结束时触发此事件，即鼠标的按钮被释放了
            'ondragenter',//当对象被鼠标拖动的对象进入其容器范围内时触发此事件
            'ondragleave',//当对象被鼠标拖动的对象离开其容器范围内时触发此事件
            'ondragover',//当某被拖动的对象在另一对象容器范围内拖动时触发此事件
            'ondragstart',//当某对象将被拖动时触发此事件
            'ondrop',//在一个拖动过程中，释放鼠标键时触发此事件
            'onerrorupdate',//当使用onBeforeUpdate事件触发取消了数据传送时，代替onAfterUpdate事件
            'onlosecapture',//当元素失去鼠标移动所形成的选择焦点时触发此事件
            'ondurationchange',//当视频的时长发生变化时执行 JavaScript
            'onemptied',
            'onended',//当音频播放结束后执行 JavaScript
            'onfinish',//当Marquee元素完成需要显示的内容后触发此事件
            'onfilterchange',//当某个对象的滤镜效果发生变化时触发的事件
            'onformdata',
            'onfullscreenchange',//实现全屏、退出全屏操作
            'onfullscreenerror',//属性是一个事件处理器用于处理 fullscreenchange 事件,在当前文档不能进入全屏模式，即使它被请求时触发
            'ongotpointercapture',//是一个Element 接口的EventHandler 属性，返回一个gotpointercapture 事件类型的事件句柄 (function) .
            'onhelp',//当浏览者按下F1或者浏览器的帮助选择时触发此事件
            'oninput',//当用户向 <input> 中尝试输入时执行 JavaScript
            'oninvalid',//当提交<input>元素无效时，会发生oninvalid事件
            'onloadeddata',//在当前帧的数据可用时执行 JavaScript ( <video>)
            'onloadedmetadata',//在视频的元数据加载后执行 JavaScript
            'onloadstart',//在视频开始加载时执行 JavaScript
            'onlostpointercapture',//GlobalEventHandlers接口的onlostpointercapture EventHandler属性返回lostpointercapture事件类型的事件处理程序（函数）
            'onmouseenter',//当鼠标指针移动到图像时执行 JavaScript
            'onmouseleave',//在鼠标指针移出指针时执行 JavaScript
            'onmousewheel',//滚轮事件
            'onmove',//浏览器的窗口被移动时触发此事件
            'onpaste',//当内容被粘贴时触发此事件
            'onpause',//当内容被粘贴时触发此事件
            'onplay',//在视频开始播放时执行 JavaScript
            'onplaying',//在视频暂停后准备开始播放时执行 JavaScript
            'onpointercancel',
            'onpointerdown',
            'onpointerenter',
            'onpointerleave',
            'onpointermove',
            'onpointerout',
            'onpointerover',
            'onpointerrawupdate',
            'onpointerup',
            'onprogress',
            'onpropertychange',//当对象的属性之一发生变化时触发此事件
            'onratechange',
            'onreadystatechange',//当对象的初始化属性值发生变化时触发此事件
            'onrowexit',//当前数据源的数据将要发生变化时触发的事件
            'onrowenter',//当前数据源的数据发生变化并且有新的有效数据时触发的事件
            'onrowsdelete',//当前数据记录将被删除时触发此事件
            'onrowsinserted',//当前数据源将要插入新数据记录时触发此事件
            'onscroll',//浏览器的滚动条位置发生变化时触发此事件
            'onstop',//浏览器的停止按钮被按下时触发此事件或者正在下载的文件被中断
            'onsearch',
            'onseeked',
            'onseeking',
            'onselectionchange',
            'onselectstart',//当文本内容选择将开始发生时触发的事件
            'onstalled',
            'onstart',//当Marquee元素开始显示内容时触发此事件
            'onsuspend',
            'ontimeupdate',
            'ontoggle',
            'onvolumechange',
            'onwaiting',
            'onwebkitfullscreenchange',
            'onwebkitfullscreenerror',
            'onwheel',
        ]*/
        let event_listener = {
            abort                   : 'onabort',
            blur                    : 'onblur',
            change                  : 'onchange',
            click                   : 'onclick',
            dblclick                : 'ondblclick',
            error                   : 'onerror',
            focus                   : 'onfocus',
            keydown                 : 'onkeydown',
            keypress                : 'onkeypress',
            keyup                   : 'onkeyup',
            load                    : 'onload',
            mousedown               : 'onmousedown',
            mousemove               : 'onmousemove',
            mouseout                : 'onmouseout',
            mouseover               : 'onmouseover',
            mouseup                 : 'onmouseup',
            reset                   : 'onreset',
            resize                  : 'onresize',
            select                  : 'onselect',
            submit                  : 'onsubmit',
            unload                  : 'onunload',
            afterprint              : 'onafterprint',
            afterupdate             : 'onafterupdate',
            auxclick                : 'onauxclick',
            beforecopy              : 'onbeforecopy',
            beforecut               : 'onbeforecut',
            beforeeditfocus         : 'onbeforeeditfocus',
            beforepaste             : 'onbeforepaste',
            beforeprint             : 'onbeforeprint',
            beforeupdate            : 'onbeforeupdate',
            bounce                  : 'onbounce',
            cancel                  : 'oncancel',
            canplay                 : 'oncanplay',
            canplaythrough          : 'oncanplaythrough',
            cellchange              : 'oncellchange',
            close                   : 'onclose',
            contextmenu             : 'oncontextmenu',
            copy                    : 'oncopy',
            cuechange               : 'oncuechange',
            cut                     : 'oncut',
            dataavailable           : 'ondataavailable',
            datasetchanged          : 'ondatasetchanged',
            datasetcomplete         : 'ondatasetcomplete',
            drag                    : 'ondrag',
            dragdrop                : 'ondragdrop',
            dragend                 : 'ondragend',
            dragenter               : 'ondragenter',
            dragleave               : 'ondragleave',
            dragover                : 'ondragover',
            dragstart               : 'ondragstart',
            drop                    : 'ondrop',
            errorupdate             : 'onerrorupdate',
            losecapture             : 'onlosecapture',
            durationchange          : 'ondurationchange',
            emptied                 : 'onemptied',
            ended                   : 'onended',
            finish                  : 'onfinish',
            filterchange            : 'onfilterchange',
            formdata                : 'onformdata',
            fullscreenchange        : 'onfullscreenchange',
            fullscreenerror         : 'onfullscreenerror',
            gotpointercapture       : 'ongotpointercapture',
            help                    : 'onhelp',
            input                   : 'oninput',
            invalid                 : 'oninvalid',
            loadeddata              : 'onloadeddata',
            loadedmetadata          : 'onloadedmetadata',
            loadstart               : 'onloadstart',
            lostpointercapture      : 'onlostpointercapture',
            mouseenter              : 'onmouseenter',
            mouseleave              : 'onmouseleave',
            mousewheel              : 'onmousewheel',
            move                    : 'onmove',
            paste                   : 'onpaste',
            pause                   : 'onpause',
            play                    : 'onplay',
            playing                 : 'onplaying',
            pointercancel           : 'onpointercancel',
            pointerdown             : 'onpointerdown',
            pointerenter            : 'onpointerenter',
            pointerleave            : 'onpointerleave',
            pointermove             : 'onpointermove',
            pointerout              : 'onpointerout',
            pointerover             : 'onpointerover',
            pointerrawupdate        : 'onpointerrawupdate',
            pointerup               : 'onpointerup',
            progress                : 'onprogress',
            propertychange          : 'onpropertychange',
            ratechange              : 'onratechange',
            readystatechange        : 'onreadystatechange',
            rowexit                 : 'onrowexit',
            rowenter                : 'onrowenter',
            rowsdelete              : 'onrowsdelete',
            rowsinserted            : 'onrowsinserted',
            scroll                  : 'onscroll',
            stop                    : 'onstop',
            search                  : 'onsearch',
            seeked                  : 'onseeked',
            seeking                 : 'onseeking',
            selectionchange         : 'onselectionchange',
            selectstart             : 'onselectstart',
            stalled                 : 'onstalled',
            start                   : 'onstart',
            suspend                 : 'onsuspend',
            timeupdate              : 'ontimeupdate',
            toggle                  : 'ontoggle',
            volumechange            : 'onvolumechange',
            waiting                 : 'onwaiting',
            webkitfullscreenchange  : 'onwebkitfullscreenchange',
            webkitfullscreenerror   : 'onwebkitfullscreenerror',
            wheel                   : 'onwheel',
        }
        if(Object.keys(event_listener).indexOf(propName) !==  -1){
            el[event_listener[propName]] = typeof props[propName] === 'function' ? props[propName] : ((function(args){
                return function (e) {
                    return props[propName].fn(e, ...args)
                }
            })(props[propName].arg));
        }else{
            el.setAttribute(propName, props[propName]);
        }
    }

    this.children.forEach((child) => {
        let childEl = (child instanceof VD) ? child.render() : document.createTextNode(child);
        el.appendChild(childEl);
    });

    return el;
};

/**
 * 虚拟节点属性更新
 * [diffProps description]
 * @param  {[type]} oldNode [description]
 * @param  {[type]} newNode [description]
 * @return {[type]}         [description]
 */
export function diffProps(oldNode, newNode) {
    let oldProps = oldNode.props;
    let newProps = newNode.props;
    let key;
    let propsPatches = {};
    let isSame = true;
    // find out different props
    for (key in oldProps) {
        if (newProps[key] !== oldProps[key]) {
            isSame = false;
            propsPatches[key] = newProps[key];
        }
    }
    // find out new props
    for (key in newProps) {
        if (!oldProps.hasOwnProperty(key)) {
            isSame = false;
            propsPatches[key] = newProps[key];
        }
    }
    return isSame ? null : propsPatches;
}



// WEBPACK FOOTER //
// ./src/assets/js-plug-in-unit/unit.js